import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c('h1',[_vm._v("キャラクターについて")]),_c('p',[_vm._v("当サイトのマスコット達です。")]),_c('img',{attrs:{"src":require("../../../public/img/soramaru/characters.png"),"alt":""}}),_c('p',[_vm._v("\n    イラスト：かみとすみ\n    (\n    "),_c('a',{attrs:{"target":"_blank","href":"https://twitter.com/kami_to_sumi"}},[_vm._v("@kami_to_sumi")]),_vm._v(")\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }